import { SITE_VARIABLES } from '../../themes/variables'

export const getIconStyles = (fill: string) => {
    const getSvgColor = (fill: string) => {
        switch (fill) {
            case 'dark':
                return SITE_VARIABLES.COLORS.DARK
            case 'light':
                return SITE_VARIABLES.COLORS.LIGHT
            case 'link':
                return SITE_VARIABLES.COLORS.LINK
            default:
                break
        }
    }

    return {
        icon: {
            display: 'flex',
            width: '100%',
            height: '100%',
            svg: {
                width: '100%',
                height: '100%',
                fill: getSvgColor(fill),
            },
        },
    }
}
